




























import { get } from 'lodash';

import ZenMultiselect from '@reciprocity/multiselect';

import { filterPresenterMixin } from './common';

export interface DropdownItem {
  key: string;
  value: string;
}

export default {
  name: 'BooleanFilterAttributePresenter',
  components: {
    ZenMultiselect,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  data() {
    return {
      items: [],
      dataActiveItem: [] as DropdownItem[],
    };
  },
  computed: {
    // TODO: temp until GQL allows for a cleaner implementation
    computedItems() {
      const attributeToItems: { [key: string]: object[] } = {
        // Watching
        watchers: [
          {
            key: 'Yes',
            value: 1,
          },
          {
            key: 'No',
            value: 0,
          },
        ],
        // AuditType
        internal: [
          {
            key: 'Internal',
            value: 1,
          },
          {
            key: 'External',
            value: 0,
          },
        ],
        // Significance
        keyControl: [
          {
            key: 'Key',
            value: 1,
          },
          {
            key: 'Non-Key',
            value: 0,
          },
        ],
      };
      const defaultItems: object[] = [
        {
          key: 'Yes',
          value: 1,
        },
        {
          key: 'No',
          value: 0,
        },
      ];

      return get(attributeToItems, this.attribute, defaultItems);
    },
    computedPlaceholder(): string {
      return this.placeholder;
    },
    selection(): string {
      return this.dataActiveItem.value;
    },
  },
  methods: {
    updateActiveItem(item: DropdownItem): void {
      if (this.attribute == 'keyControl' || this.attribute == 'internal' || this.attribute == 'watchers') {
        this.$emit('input', item.key);
      } else {
        this.$emit('input', item.value);
      }
    },
  },
};
